export function calculatePercentageDiscount(newPrice, oldPrice) {
  return Math.floor((oldPrice * 1000 - newPrice * 1000) / (oldPrice * 10));
}
